export const Status = {
  ALL: "success",
  SOME: "ongoing",
  NONE: "errorRed",
};

export const HttpStatus = {
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
};
